<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="detailDialogVisible"
        center
        class="detail-dialog-container"
        width="1000px">
        <div class="dialog-container flex flex-direction ">
            <div class="dialog-content flex flex-direction">
                <div class="title">{{ detail.title }}</div>
                <div class="content flex flex-direction">
                    <div v-html="detail.content"></div>
                    <div class="time self-end">{{ detail.add_time }}</div>
                </div>
            </div>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate black" @click="cancel">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {getVersionDetail} from '@/api/login'
import {zhDate} from '@/utils/utils'

export default {
    components: {},
    name: "VersionDetailDialog",
    props: {
        detailDialogVisible: {
            type: Boolean,
            default: false
        },
        nid: { //详情ID
            type: Number,
        },
    },
    data() {
        return {
            detail: '',
            applyDialogVisible: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.init()
    },
    methods: {
        async init() {
            let _data = await getVersionDetail(this.nid)
            if (_data.status === 200) {
                _data.data.create_time = zhDate(_data.data.create_time * 1000)
                this.detail = _data.data
            }
        },
        cancel() {
            this.$emit('watchState', false)
        },

    },
    watch: {
        detailDialogVisible() {

        },
        nid() {
            this.detail = ''
            this.init()
        }
    }
}
</script>

<style lang="scss" scoped>

.detail-dialog-container {
    .dialog-container {
        height: 600px;

        .dialog-header {
            height: 55px;
            padding: 0 20px;
            border-bottom: 1px solid #eeeeee;

            .header-logo {
                width: 30px;
                height: 30px;
                border-radius: 30px;
            }

            .header-name {
                font-size: 16px;
                color: #0a2240;
                margin-left: 6px;
            }

            .dialog-close {
                font-size: 21px;
                color: #0a2240;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .dialog-content {
            padding: 40px 80px;
            height: 605px;

            .title {
                font-size: 24px;
                font-weight: bold;
                color: #0a2240;
                text-align: center;
            }

            .content {
                margin-top: 38px;
                overflow-y: scroll;

                &::-webkit-scrollbar {
                    display: none
                }

            }

            .time {
                font-size: 16px;
                color: #0a2240;
                margin-top: 16px;
            }
        }

        .dialog-operate {
            height: 100px;

            .operate {
                width: 200px;
                height: 40px;
                border-radius: 20px;
                font-size: 16px;
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                color: #ffffff;

                &.black {
                    background: #0a2240 none;
                }

                &.disabled {
                    background: #b4c7e5 none;
                }
            }

            .operate + .operate {
                margin-left: 80px;
            }
        }

        .dialog-footer {
            height: 40px;
            background-color: #e7eff9;
            padding: 0 20px;
            border-radius: 0 0 10px 10px;

            .content {
                font-size: 16px;
                color: #8b9fbe;
            }
        }
    }
}
</style>